import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';


function quotes() {
    const quotes = $qsa('[data-name="quotes-slider"]');

    if (!quotes) return;

    [...quotes].forEach((quote) => {
        let width = quote.offsetWidth;
        const content = $qsa('[data-name="quotes-slider-content"]', quote);
        const slides = $qsa('[data-name="quotes-slider-slide"]', quote);
        const controls = $qsa('[data-name="quotes-slider-control"]', quote);
        const labels = $qsa('[data-name="quotes-slider-label"]', quote);
        const controlWidth = 110;
        let contentWidth = width - controlWidth * slides.length ;
        let currentSlide = 0;
        let maxHeight = 400;
        // console.info(contentWidth);
        gsap.set(content, {width: contentWidth + controlWidth + 'px'});
        [...content].forEach((slide) => {
            if(slide.offsetHeight > maxHeight){ maxHeight = slide.offsetHeight }
        })
        gsap.set(content, {height: maxHeight + 'px'});
        gsap.set(quote, {height: maxHeight  + 'px'});
        gsap.set(labels, {width: maxHeight  + 'px'});
        gsap.set(labels[0], {opacity: 0});
        gsap.set(slides[0], {width: contentWidth + controlWidth + 'px'});
        gsap.set(content[0], {opacity: 1});

        
        [...controls].forEach((control) => {
            control.addEventListener('click', (e) => {
                gsap.to(slides[currentSlide], {width: controlWidth + 'px'});
                gsap.to(content[currentSlide], {opacity: 0});
                gsap.to(labels[currentSlide], {opacity: 1});
                gsap.to(slides[e.target.dataset.value], {width: contentWidth + controlWidth + 'px'});
                gsap.to(content[e.target.dataset.value], {opacity: 1});
                gsap.to(labels[e.target.dataset.value], {opacity: 0});
                gsap.to
                currentSlide = e.target.dataset.value

            })
        });

        addEventListener("resize", (event) => {
            // console.info('resize');
             width = quote.offsetWidth;
             contentWidth = width - controlWidth * slides.length ;
             gsap.set(content, {width: contentWidth + controlWidth + 'px'});

             [...content].forEach((slide) => {
                if(slide.offsetHeight > maxHeight){ maxHeight = slide.offsetHeight }
            })
            gsap.set(content, {height: maxHeight + 'px'});
            gsap.set(quote, {height: maxHeight  + 'px'});
            gsap.set(labels, {width: maxHeight  + 'px'});
    
        });
        
        
        // need to loop through and get max height?

        // get container width

        // const content = $qs('[data-target="accordion-content"]', accordion);

        // trigger.addEventListener('click', () => {
        //     const { state } = accordion.dataset;

        //     closeAllAccordions(accordions);

        //     if (state === 'closed') {
        //         accordion.dataset.state = 'open';
        //         gsap.to(content, { height: 'auto', duration: 0.5 });
        //     } else {
        //         accordion.dataset.state = 'closed';
        //         gsap.to(content, { height: 0, duration: 0.5 });
        //     }
        // });
    });

 

}

export default quotes;